import React, { useState } from 'react';
import {
  AppBar,
  Box,
  Button,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Toolbar,
  Fade,
  Zoom,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Link } from 'react-router-dom';
import logo from '../assets/logo.png';

function HomeNavbar() {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [authorMenuAnchor, setAuthorMenuAnchor] = useState(null);

  const handleDrawerToggle = () => {
    setOpenDrawer((prev) => !prev);
  };

  const handleDropdownOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };

  const handleAuthorMenuOpen = (event) => {
    setAuthorMenuAnchor(event.currentTarget);
  };

  const handleAuthorMenuClose = () => {
    setAuthorMenuAnchor(null);
  };

  const navItems = [
    // { label: 'Volumes', link: '/volumes' },
    { label: 'Articles', link: 'https://journal.wajls.com/' },
    { label: 'Editorial Board', link: '/editorial-board' },
    { label: 'Peer Reviewers', link: '/peer-reviewers' },
  ];

  const contributionLinks = [
    { label: 'Join Editorial Board', link: '/join-editorial-board' },
    { label: 'Join Peer Review', link: '/join-peer-review' },
  ];

  const forAuthorsLinks = [
    { label: 'Author Dashboard', link: '/author-dashboard' },
    { label: 'Publishing Guidelines', link: '/publishing-guidelines' },
  ];

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: '#121212',
          color: '#fff',
          borderBottom: '1px solid #333',
        }}
      >
        <Toolbar
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            px: { xs: 2, md: 4 },
          }}
        >
          <Box
            component={Link}
            to="/"
            sx={{
              display: 'flex',
              alignItems: 'center',
              textDecoration: 'none',
            }}
          >
            <img src={logo} alt="QJournal Logo" style={{ height: 40 }} />
          </Box>

          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 3 }}>
            {navItems.map((item) => (
              <Button
                key={item.label}
                component={Link}
                to={item.link}
                sx={{
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                {item.label}
              </Button>
            ))}

            <Button
              onClick={handleDropdownOpen}
              endIcon={<ArrowDropDownIcon />}
              sx={{
                color: '#fff',
                textTransform: 'none',
                fontWeight: 500,
              }}
            >
              Contribution
            </Button>

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleDropdownClose}
              MenuListProps={{ sx: { backgroundColor: '#1e1e1e' } }}
            >
              {contributionLinks.map((item) => (
                <MenuItem
                  key={item.label}
                  component={Link}
                  to={item.link}
                  onClick={handleDropdownClose}
                  sx={{ color: '#fff' }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>

            <Button
              onClick={handleAuthorMenuOpen}
              endIcon={<ArrowDropDownIcon />}
              sx={{
                color: '#fff',
                textTransform: 'none',
                fontWeight: 500,
              }}
            >
              For Authors
            </Button>

            <Menu
              anchorEl={authorMenuAnchor}
              open={Boolean(authorMenuAnchor)}
              onClose={handleAuthorMenuClose}
              MenuListProps={{ sx: { backgroundColor: '#1e1e1e' } }}
            >
              {forAuthorsLinks.map((item) => (
                <MenuItem
                  key={item.label}
                  component={Link}
                  to={item.link}
                  onClick={handleAuthorMenuClose}
                  sx={{ color: '#fff' }}
                >
                  {item.label}
                </MenuItem>
              ))}
            </Menu>

            <Button
                key="t&c"
                component={Link}
                to='/terms-and-conditions'
                sx={{
                  color: '#fff',
                  textTransform: 'none',
                  fontWeight: 500,
                }}
              >
                Terms and Conditions
              </Button>
          </Box>

          <IconButton
            edge="start"
            color="inherit"
            sx={{ display: { xs: 'block', md: 'none' } }}
            onClick={handleDrawerToggle}
          >
            <MenuIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      <Drawer
        anchor="top"
        open={openDrawer}
        onClose={handleDrawerToggle}
        PaperProps={{
          sx: {
            backgroundColor: '#121212',
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            position: 'relative',
          },
        }}
        transitionDuration={300}
      >
        <Fade in={openDrawer} timeout={400}>
          <Zoom in={openDrawer} timeout={400}>
            <Box sx={{ textAlign: 'center' }}>
              <IconButton
                onClick={handleDrawerToggle}
                sx={{
                  position: 'absolute',
                  top: 20,
                  right: 20,
                  color: '#fff',
                }}
              >
                <CloseIcon />
              </IconButton>

              <List>
                {navItems.map((item) => (
                  <ListItem key={item.label} disablePadding>
                    <ListItemText>
                      <Link
                        to={item.link}
                        style={{
                          textDecoration: 'none',
                          color: '#fff',
                          padding: '12px 16px',
                          display: 'block',
                          fontSize: '1.3rem',
                          fontWeight: 500,
                        }}
                        onClick={handleDrawerToggle}
                      >
                        {item.label}
                      </Link>
                    </ListItemText>
                  </ListItem>
                ))}

                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          color: '#bbb',
                          fontSize: '1.1rem',
                          fontWeight: 500,
                          textTransform: 'uppercase',
                          mt: 2,
                          mb: 1,
                        }}
                      >
                        Contribution
                      </Typography>
                    }
                  />
                </ListItem>

                {contributionLinks.map((item) => (
                  <ListItem key={item.label} disablePadding sx={{ pl: 3 }}>
                    <ListItemText>
                      <Link
                        to={item.link}
                        style={{
                          textDecoration: 'none',
                          color: '#fff',
                          padding: '10px 16px',
                          display: 'block',
                          fontSize: '1.2rem',
                        }}
                        onClick={handleDrawerToggle}
                      >
                        {item.label}
                      </Link>
                    </ListItemText>
                  </ListItem>
                ))}

                <ListItem>
                  <ListItemText
                    primary={
                      <Typography
                        sx={{
                          color: '#bbb',
                          fontSize: '1.1rem',
                          fontWeight: 500,
                          textTransform: 'uppercase',
                          mt: 3,
                          mb: 1,
                        }}
                      >
                        For Authors
                      </Typography>
                    }
                  />
                </ListItem>

                {forAuthorsLinks.map((item) => (
                  <ListItem key={item.label} disablePadding sx={{ pl: 3 }}>
                    <ListItemText>
                      <Link
                        to={item.link}
                        style={{
                          textDecoration: 'none',
                          color: '#fff',
                          padding: '10px 16px',
                          display: 'block',
                          fontSize: '1.2rem',
                        }}
                        onClick={handleDrawerToggle}
                      >
                        {item.label}
                      </Link>
                    </ListItemText>
                  </ListItem>
                ))}

                <ListItem key="t&c" disablePadding>
                  <ListItemText>
                    <Link
                      to='/terms-and-conditions'
                      style={{
                        textDecoration: 'none',
                        color: '#fff',
                        padding: '12px 16px',
                        display: 'block',
                        fontSize: '1.3rem',
                        fontWeight: 500,
                      }}
                      onClick={handleDrawerToggle}
                    >
                      Terms and Conditions
                    </Link>
                  </ListItemText>
                </ListItem>
              </List>
            </Box>
          </Zoom>
        </Fade>
      </Drawer>
    </Box>
  );
}

export default HomeNavbar;
